/**
 * Three-state theme toggle: light / dark / system.
 *
 * Renders as a single icon button that cycles through the three states.
 * Tooltip shows the *next* state on hover. Click cycles light → dark → system.
 */
import { Monitor, Moon, Sun } from 'lucide-react';

import { useThemeStore, type Theme } from '../../stores/theme.store';
import { IconButton } from '../primitives/IconButton';

const order: Theme[] = ['light', 'dark', 'system'];

export function ThemeToggle(): JSX.Element {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
  const next = order[(order.indexOf(theme) + 1) % order.length]!;

  return (
    <IconButton
      onClick={() => setTheme(next)}
      aria-label={`Theme: ${theme}. Click for ${next}.`}
      title={`Theme: ${theme} · click for ${next}`}
    >
      <Icon className="size-4" />
    </IconButton>
  );
}
